import Index from '../../views/apply/Index.vue';
import Sign from '../../views/apply/Sign.vue';
import Log from '../../views/apply/Log.vue';
import Batch from '../../views/apply/Batch.vue';

export default [
  {
    path: '/apply/logs',
    name: 'apply.logs',
    component: Log,
    meta: {
      can: 'view apply-logs',
      breadcrumb: [
        { name: '主頁', route: "dashboard" }
      ]
    }
  },
  {
    path: '/apply/batch',
    name: 'apply.batch',
    component: Batch,
    props: true,
    meta: {
      can: 'can apply',
      breadcrumb: [
        { name: '主頁', route: "dashboard" },
        { name: '大量辦門號', route: "apply.batch" }
      ]
    }
  },
  {
    path: '/apply/:id?',
    name: 'apply',
    component: Index,
    props: true,
    meta: {
      can: 'view apply',
      breadcrumb: [
        { name: '主頁', route: "dashboard" },
        { name: '辦門號', route: "apply" }
      ]
    }
  },
  {
    path: '/sign/:hash',
    name: 'sign',
    component: Sign,
    props: true,
    meta: {
      guest: true,
    }
  },
]
